///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ExportIcon = ({
  height,
  fill = "#0066FA",
  title = messages.export.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="export-icon"
    width={width}
    height={height}
    fill="none"
    {...rest}
  >
    <title id="export-icon">{title}</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M9 8.346H1.2V3.153h1.557S3.17 2.636 4.059 2H.6c-.332 0-.6.259-.6.576v6.347c0 .32.268.577.6.577h9c.332 0 .6-.258.6-.577V6.762L9 7.71v.635Zm-.983-4.01v2.049l3.983-3L8.017.5v1.806c-4.837 0-4.837 4.598-4.837 4.598C4.55 4.74 5.392 4.336 8.017 4.336Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ExportIcon;
